
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

const DynamicGrid = ({ columnNames, tableData, sortable, defaultsortindex, descending }) => {

    // columnNames 
    //must be an array of strings containing the names of the columns
    // Example input:
    // columns = ["ID", "Ref #", "Cust Job ID"]

    // tableData
    // an array of rows
    // each row is an array of cells
    // each cell is an object that contains a cell type and the cell's content

    // Example input:
    // rows = [row, row, row...]
    // row = [
    //     {type: "link", content: {text: 'DP001159', link: '/designFolder/details/b7dc6303-6a8d-40b7-8eb2-f106b8c953cf'}},
    //     {type: "text", content: {text: "22-138020-R0"}},
    //     {type: "text", content: {text: "M&E 22-21"}},
    //     {type: "modal", content: {text: "E1", target: "#editComponent", dataID: "81EBBEF7-C246-4226-AFC7-20FAE07875B3"}},
    //     {type: "function", content: {text: c[2], fx: hello, arg: c[0]}},
    //     {type: "modalfunction", content: {text: "Click Me", fx: hello, arg: c[0], target: "#editComponent", dataID: c[0]}},
    // ];

    // sortable
    // When true, draws search box and adds sort buttons in header

    //defaultsortindex (optional): supply the index of the column to sort data by on load

    // descending (optional): true/false
    // will toggle ascending / descending sort order 

    const [sortByIndex, setSortByIndex] = useState(0);

    const [reverse, setReverse] = useState(() => { if (descending) { return true; } else { return false; } });

    const [filteredRows, setFilteredRows] = useState([]);

    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        if (defaultsortindex != undefined) {
            setSortByIndex(defaultsortindex);
        }
    }, [])

    let columns = [];

    let rows = [];

    // const checkCellContent = (cell) => {

    //     //try parsing cell as a date, if successful, treat as short date
    //     if (Date.parse(cell)) { return "shortDate"; }

    //     //Check is cell is a number
    //     else if (!isNaN(parseFloat(cell))) { return "number"; }

    //     //Check if cell is a string
    //     else { return "string"; }

    // }

    const checkCellContent = (cell) => {
        // Regular expression to match date formats (e.g., "YYYY-MM-DD", "MM/DD/YYYY")
        const dateRegex = /^\d{4}[-/]\d{2}[-/]\d{2}$|^\d{2}[-/]\d{2}[-/]\d{4}$/;

        // Check if cell matches date format
        if (typeof cell === "string" && dateRegex.test(cell)) {
            return "shortDate";
        }

        // Check if cell is a number
        else if (!isNaN(parseFloat(cell)) && isFinite(cell)) {
            return "number";
        }

        // Default to treating the cell as a string
        return "string";
    };


    //add keys to headers, rows, and cells
    if (columnNames && tableData) {

        //for each column...
        columnNames.forEach((cn, i) => {
            columns.push({ "key": i, "col": cn });
        });

        let sorted = [];
        if (tableData.length > 0) {

            let firstCellData = tableData[0][sortByIndex]["content"]["text"];
            //sort data based on the format of the cell in the first row of the column specified

            switch (checkCellContent(firstCellData)) {
                case "shortDate":
                    //console.log(`Sorting by "${columnNames[sortByIndex]}" as short date, ${reverse ? "descending" : "ascending"}`)
                    sorted = tableData.sort((a, b) =>
                        new Date(a[sortByIndex]["content"]["text"]) - new Date(b[sortByIndex]["content"]["text"]));
                    break;

                case "number":
                    //console.log(`Sorting by "${columnNames[sortByIndex]}" as number, ${reverse ? "descending" : "ascending"}`)
                    sorted = tableData.sort((a, b) =>
                        a[sortByIndex]["content"]["text"] - b[sortByIndex]["content"]["text"]);
                    break;

                case "string":
                    //console.log(`Sorting by "${columnNames[sortByIndex]}" as string, ${reverse ? "descending" : "ascending"}`)
                    sorted = tableData.sort((a, b) => {
                        if (a[sortByIndex]["content"]["text"] > b[sortByIndex]["content"]["text"]) {
                            return 1;
                        }
                        else {
                            return -1;
                        }
                    });
                    break;

                default:
                    console.log("Sorting alphabetically by default...");
                    sorted = tableData.sort((a, b) => {
                        if (a[sortByIndex]["content"]["text"] > b[sortByIndex]["content"]["text"]) {
                            return 1;
                        }
                        else {
                            return -1;
                        }
                    });
                    break;
            }
        }

        //If reverse order is toggled, reverse the data
        reverse ? tableData = sorted.reverse() : tableData = sorted;

        //for each row...
        tableData.forEach((row, i) => {
            let obj = {};
            obj["key"] = i;

            obj["row"] = [];

            //for each cell in the row...
            row.forEach((cell, j) => {
                let innerObj = {};
                innerObj["key"] = j;
                innerObj["cell"] = cell;

                obj["row"].push(innerObj);

            });
            rows.push(obj);
        });

        //add search string to each row
        rows.forEach((row, index) => {
            row["searchstring"] = "";

            row["row"].forEach((cell) => {

                if (cell["cell"]["content"]["text"] != null) {
                    row["searchstring"] += `[${cell["cell"]["content"]["text"].toString()}]`;
                }

            });
            row["searchstring"] = row["searchstring"].toUpperCase();

        });

    }

    const handleClickSort = (index) => {

        //If user clicks the sort button on the column that the
        //table is already being sorted by, reverse the sort order 
        //Ex: A-Z => Z-A OR Z-A => A-Z
        index == sortByIndex ? setReverse(!reverse) : setReverse(reverse);
        setSortByIndex(index);

    };

    const handleFunction = (functionObj, arg) => {
        let functionToCall = functionObj;
        functionToCall(arg);
    }

    const handleSearch = (e) => {
        setSearchTerm(e.target.value.toString().toUpperCase());
    }

    const handleClearSearch = (e) => {
        document.getElementById("dgsearchBox").value = "";
        setSearchTerm("");

    }

    useEffect(() => {
        let t = [];

        if (searchTerm != null && searchTerm != undefined && searchTerm != "") {
            rows.forEach((row, index) => {
                if (row["searchstring"].includes(searchTerm)) {
                    t.push(row);
                }
            });

        }
        else {
            t = rows;
        }

        setFilteredRows(t);
    }, [searchTerm]);

    const DGcell = (props) => {

        let cell = props.cell;

        return (
            <>

                {/* Nav Link */}
                {cell["cell"]["type"] == "link" && <Link to={cell["cell"]["content"]["link"]}>{cell["cell"]["content"]["text"]}</Link>}

                {/* Plain Text */}
                {cell["cell"]["type"] == "text" && cell["cell"]["content"]["text"]}

                {/* Launch Modal */}
                {cell["cell"]["type"] == "modal" &&
                    <button className="btn-link js-edit" style={{ textAlign: "left" }} data-bs-toggle="modal" data-bs-target={cell["cell"]["content"]["target"]} data-id={cell["cell"]["content"]["dataID"]}>
                        {cell["cell"]["content"]["text"]}
                    </button>
                }

                {/* Execute function with single parameter */}
                {cell["cell"]["type"] == "function" &&
                    <button className="btn-link js-edit" style={{ textAlign: "left" }} onClick={() => { handleFunction(cell["cell"]["content"]["fx"], cell["cell"]["content"]["arg"]) }}>
                        {cell["cell"]["content"]["text"]}
                    </button>
                }

                {/* Execute function with single parameter AND launch modal */}
                {cell["cell"]["type"] == "modalfunction" &&
                    <button className="btn-link js-edit" style={{ textAlign: "left" }} data-bs-toggle="modal" data-bs-target={cell["cell"]["content"]["target"]} data-id={cell["cell"]["content"]["dataID"]}
                        onClick={() => { handleFunction(cell["cell"]["content"]["fx"], cell["cell"]["content"]["arg"]) }}>
                        {cell["cell"]["content"]["text"]}
                    </button>
                }
            </>
        );
    }

    return (
        <>
            {sortable &&
                <div className="dataTables_filter" style={{ fontWeight: "normal", display: "flex", flexDirection: "row", alignItems: "right", justifyContent: "flex-end", marginBottom: "12px" }}>
                    <label style={{ marginTop: "4px" }}>Search:</label>
                    <input onChange={(e) => { handleSearch(e) }} id="dgsearchBox" type="search" style={{ marginLeft: "8px" }} className="form-control input-sm" placeholder="" aria-controls="designFolders" autoComplete="off" />
                    <button onClick={(e) => { handleClearSearch(e) }} className="btn btn-light" style={{ padding: "2px 8px", marginLeft: "4px" }}> Clear </button>
                </div>
            }

            <div className="dg" style={{ overflow: "scroll", margin: "auto", borderBottom: "2px solid var(--bs-gray-100)", maxWidth: "100%", maxHeight: "75vh" }}>
                <table className="table table-striped">
                    <thead style={{ position: "sticky", top: "-1px", zIndex: "100", backgroundColor: "var(--bs-light)" }}>
                        <tr>

                            {columns.map((c, i) => (
                                <th key={i} className={sortable ? "unselectable" : ""} style={{ width: "auto", border: "1px solid var(--bs-gray-300)", padding: "8px", paddingRight: "16px" }} onClick={sortable ? () => handleClickSort(c["key"]) : undefined}>

                                    {sortable
                                        ? (<div className="unselectable">{c["col"]}&nbsp;&nbsp;<span style={{ color: "var(--bs-gray-700)" }}>⇵</span></div>)
                                        : (<div>{c["col"]}</div>)}

                                </th>
                            ))}

                        </tr>
                    </thead>

                    <tbody style={{ boxShadow: "inset 0px 1px 1px 1px var(--bs-dark)" }}>
                        {searchTerm !== ""
                            ? filteredRows.map((r, i3) => (
                                <tr key={i3}>
                                    {r["row"].map((cell, i4) => (
                                        <td key={i4} style={{ width: "auto", padding: "8px", paddingRight: "16px", border: "1px solid var(--bs-gray-300)", color: "var(--bs-dark)", backgroundColor: "var(--bs-light)" }}>
                                            <DGcell cell={cell} />
                                        </td>

                                    ))}
                                </tr>
                            ))
                            : rows.map((r, i5) => (
                                <tr key={i5}>
                                    {r["row"].map((cell, i6) => (
                                        <td key={i6} style={{ width: "auto", padding: "8px", paddingRight: "16px", border: "1px solid var(--bs-gray-300)", color: "var(--bs-dark)", backgroundColor: "var(--bs-light)" }}>
                                            <DGcell cell={cell} />
                                        </td>
                                    ))}
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>

            {(sortable && columns && columns.length > 0 && rows && rows.length > 0)
                ? (<div className="dataTables_info" style={{ marginTop: "4px", opacity: "0.5", width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <span>
                        <b>{searchTerm === "" ? rows.length.toLocaleString() : filteredRows.length}</b> rows, sort by
                        <span style={{}}> <i>{columns[sortByIndex]["col"]}</i>, {(reverse ? "desc" : "asc")}</span>
                    </span>
                </div>)
                : (<>No Rows Found</>)
            }



        </>
    );
}

export default DynamicGrid;